export type SetSessionPayload =
{
    sessionId: string;
    isActiveSession: boolean;
};

export interface SetSessionId
{
    type: "SET_SESSION_ID";
    payload: SetSessionPayload;
}


export type SetSessionIdActionTypes = SetSessionId;

export function setSessionId(sessionId: string, isActiveSession: boolean): SetSessionIdActionTypes
{
    return {
        type: "SET_SESSION_ID",
        payload: {
            sessionId,
            isActiveSession,
        },
    };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/session/src/actions/Actions.ts